import React from 'react';

function AboutUsArea() {


  return (
	  <section className="about-us-area pt-90 pb-120">

<div className="container custom-container">
    <div className="row align-items-center">
        <div className="col-lg-6 order-0 order-lg-2">
            <div className="third-about-img text-right position-relative">
                <img src="assets/img/images/third_about_img.png" className="main-img" alt=""/>
                {/* <img src="assets/img/images/third_about_img_shadow.png" className="shadow" alt=""/> */}
            </div>
        </div>
        <div className="col-lg-6">
            <div className="third-about-content">
                <div className="third-title-style">
                    <h2><span>GPSINSTALL</span></h2>
                    <div className="inner">
                         
                        <p>Nasza firma specjalizuje się w profesjonalnym montażu oraz serwisu systemów GPS do pojazdów samochodowych. Działamy ściśle współpracując z firmami, które dostarczają rozwiązania lokalizacyjne. </p>
                        <br/>
                        <p>Nasza rola skupia się na bezpośredniej wizycie oraz montażu urządzeń GPS w pojazdach u klienta, zapewniamy szybkie i precyzyjne wdrożenie lokalizatorów. </p>
                        <br/>
                    <p>Z naszym doświadczeniem w montażu, gwarantujemy najwyższą jakość oraz niezawodność instalacji. Prowadzimy również serwis niedziałajacych urzędzeń, wspierając naszych partnerów biznesowych.</p>
                    <br/>
                    <h4>DZIAŁAMY NA TERENIE CAŁEGO WOJEWÓDZTWA WARMIŃSKO MAZURSKIEGO!</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
   <div className="see-my-info-wrap pt-110">
        <div className="row">
            <div className="col-12">
                <div className="section-title  h2 text-center">
                    <h2>CO NAS <span>WYRÓŻNIA?</span></h2>
                    <br/>
                    <br/>
                </div>
            </div>
        </div>
        <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-6 col-sm-8">
                <div className="my-info-box mb-30">
                    <div className="my-info-box-top">
                        <h6>Doświadczenie</h6>
                        <img src="assets/img/bg/my_info_box_hover.png" alt="" className="info-box-top-hover"/>
                    </div>
                    <div className="my-info-box-content">
                        <div className="mt-award">
                            <img src="assets/img/images/exp.png" alt=""/>
                        </div>
                    </div>

                </div>
                
            </div>
            <div className="col-xl-4 col-lg-6 col-sm-8">
                <div className="my-info-box mb-30">
                    <div className="my-info-box-top">
                        <h6>Dyspozycja</h6>
                        <img src="assets/img/bg/my_info_box_hover.png" alt="" className="info-box-top-hover"/>
                    </div>
                    <div className="my-info-box-content">
                        <div className="mt-award">
                            <img src="assets/img/images/management.png" alt=""/>
                        </div>
                    </div>
                    

                </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-sm-8">
                <div className="my-info-box mb-30">
                    <div className="my-info-box-top">
                        <h6>Jakość</h6>
                        <img src="assets/img/bg/my_info_box_hover.png" alt="" className="info-box-top-hover"/>
                    </div>
                    <div className="my-info-box-content">
                        <div className="mt-award">
                            <img src="assets/img/images/quality.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    </div>
</div>



        </section>



  )
}

export default AboutUsArea;
